import cloneDeep from "lodash/fp/cloneDeep";

class Controller {
  constructor($injector, $mdDialog, City, Events) {
    "ngInject";

    this.$injector = $injector;
    this.$mdDialog = $mdDialog;
    this.City = City;
    this.Events = Events;
    this.isDisabled = true;

    this.successNotificationEvent = this.Events.eventsType.onShowSuccessNotification;
    this.errorNotificationEvent = this.Events.eventsType.onShowErrorNotification;

    this.preSubmitPaymentMethods = this.preSubmitPaymentMethods.bind(this);
  }

  $onInit() {
    this.resource = this.$injector.get(this.resourceName);

    this.City.getAppliedPaymentMethods(this.cityId, {
      isCityRequired: false,
      active: true,
    }).$promise.then(
      (response) => {
        this.cityPaymentMethods = response.filter(
          ({ name }) => name !== "Cash"
        );
      },
      (response) => this.Events.emit(this.errorNotificationEvent, response.data)
    );

    this.resource[this.resourceGetMethod](this.supplySourceId, {
      isCityRequired: false,
    }).$promise.then(
      (response) => {
        this.paymentMethodsDefault = response;
        this.paymentMethodsViewModel = cloneDeep(response);
      },
      (response) => this.Events.emit(this.errorNotificationEvent, response.data)
    );
  }

  constructConfirmDialog(message) {
    return this.$mdDialog
      .confirm()
      .title(message)
      .ok("Confirm")
      .cancel("Cancel");
  }

  addNewPaymentMethod() {
    this.paymentMethodsViewModel.push({
      payment_method: {},
      references: [],
      is_primary: false,
    });
  }

  preRemovePaymentMethod(methodId, methodIndex) {
    const confirm = this.constructConfirmDialog(
      "Are you sure you want to delete this method?"
    );

    this.$mdDialog
      .show(confirm)
      .then(this.removePaymentMethod.bind(this, methodId, methodIndex));
  }

  removePaymentMethod(methodId, methodIndex) {
    if (methodId) {
      this.paymentMethodsViewModel[methodIndex].isDeleted = true;
    } else {
      this.paymentMethodsViewModel.splice(methodIndex, 1);
    }
  }

  togglePrimary(checked, methodIndex) {
    if (checked) {
      this.paymentMethodsViewModel.forEach((method, index) => {
        if (methodIndex !== index) method.is_primary = false;
      });
    }
  }

  updatePaymentObject({ _id, name, references }, methodIndex) {
    this.paymentMethodsViewModel[methodIndex].payment_method = { _id, name };
    this.paymentMethodsViewModel[
      methodIndex
    ].references = references.map((reference) => ({ field: reference }));
  }

  getNonDeleted({ isDeleted }) {
    return !isDeleted;
  }

  checkForDuplicates() {
    const omitObjectHash = ({ payment_method: { _id, name }, references }) => {
      const method = {
        payment_method: { _id, name },
        references: references.map(({ field, value }) => ({
          field,
          value,
        })),
      };

      return JSON.stringify(method);
    };

    const paymentMethodsStringified = this.paymentMethodsViewModel
      .filter(this.getNonDeleted)
      .map(omitObjectHash);

    const duplicates = [];

    paymentMethodsStringified.forEach((method, index, arr) => {
      const methodFirstMatchIndex = arr.indexOf(method);

      if (methodFirstMatchIndex !== index) {
        const methodName = this.paymentMethodsViewModel[index].payment_method
          .name;
        if (!duplicates.includes(methodName)) duplicates.push(methodName);
      }
    });

    if (duplicates.length > 0) {
      this.Events.emit(this.errorNotificationEvent, {
        message: `Same payment method${
          duplicates.length > 1 ? "s" : ""
        }: ${duplicates.join(", ")} already exist${
          duplicates.length > 1 ? "" : "s"
        }`,
      });
      return true;
    }

    return false;
  }

  formatRequestBody() {
    const formatRequestBody = ({
      _id,
      payment_method: { _id: paymentMethodId },
      references,
      is_primary: isPrimary,
    }) => {
      const method = {
        _id,
        payment_method: paymentMethodId,
        is_primary: isPrimary,
        references: references.map(({ field: { _id }, value }) => ({
          field: _id,
          value,
        })),
      };

      return method;
    };

    return this.paymentMethodsViewModel
      .filter(this.getNonDeleted)
      .map(formatRequestBody);
  }

  preSubmitPaymentMethods() {
    const confirm = this.constructConfirmDialog(
      "Are you sure you want to save your changes?"
    );

    this.$mdDialog.show(confirm).then(this.submitPaymentMethods.bind(this));
  }

  submitPaymentMethods() {
    const containsDuplicates = this.checkForDuplicates();
    if (!containsDuplicates) {
      const requestBody = this.formatRequestBody();
      this.resource[this.resourceSubmitMethod](
        this.supplySourceId,
        requestBody
      ).$promise.then(
        (response) => {
          this.isDisabled = true;
          this.paymentMethodsDefault = response;
          this.paymentMethodsViewModel = cloneDeep(response);
          this.Events.emit(this.successNotificationEvent, {
            message: `${this.supplySource} payment methods are updated successfully`,
          });
        },
        (response) =>
          this.Events.emit(this.errorNotificationEvent, response.data)
      );
    }
  }

  cancelChanges() {
    this.paymentMethodsViewModel = cloneDeep(this.paymentMethodsDefault);
    this.isDisabled = true;
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/supplySourcePaymentMethods/supplySourcePaymentMethods.controller.js